// components/ScrollToTop.jsx
import React, { useState, useEffect } from 'react';

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled down
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Set the top coordinate to 0
    // Make scrolling smooth
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <div className="scroll-to-top">
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    style={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '20px',
                        width: '50px',
                        height: '50px',
                        backgroundColor: 'var(--primary-color)',
                        color: 'white',
                        borderRadius: '50%',
                        border: 'none',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                        cursor: 'pointer',
                        zIndex: 999,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        transition: 'all 0.3s ease',
                        opacity: 0.8
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = 'var(--accent-color)';
                        e.target.style.opacity = '1';
                        e.target.style.transform = 'translateY(-3px)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'var(--primary-color)';
                        e.target.style.opacity = '0.8';
                        e.target.style.transform = 'translateY(0)';
                    }}
                    aria-label="Scroll to top"
                >
                    <i className="fas fa-arrow-up"></i>
                </button>
            )}
        </div>
    );
};

export default ScrollToTop;